export const SERVICE_CONFIG = 'service_config';
export const TIMEZONE = 'timezone-';
export const LANGUAGE = 'language-';
